







import {Vue, Component, Watch} from 'vue-property-decorator';
import VueMarkdown from 'vue-markdown';
import {nil} from '@/common';
@Component({
    components: {
        VueMarkdown
    },
})
export default class BlogPost extends Vue {
    public post = null;
    mounted(){
        //this.init();
    }
    @Watch('$route.params.permalink')
    onRoutePermalinkChanged(value: string, oldValue: string){
        this.init();
    }
    public async init(){
        let redirect = true;
        if(!nil(this.permalink)) {
            const results = await this.$FeathersVuex.Post.find({query: {permalink: this.permalink}});
            if(results.total === 1){
                redirect = false;
                this.post = results.data[0];
            }
        }
        if(redirect){
            this.$router.replace("/blog");
        }
    }
    public get permalink(){
        return this.$route.params.permalink
    }
    public get postTitle(){
        if(nil(this.post)) return '';
        return this.post.title;
    }
    public get postBody(){
        if(nil(this.post)) return '';
        return this.post.body;
    }
}
